var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative item"},[(_vm.loading)?_c('Loading'):_c('v-sheet',{attrs:{"color":"#cccccc"}},[_c('img',{staticClass:"d-flex align-center justify-center pointer-none",attrs:{"width":"100%","src":_vm.files +
        (_vm.xs && _vm.item.bottom_banner_mobile
          ? _vm.item.bottom_banner_mobile
          : _vm.item.bottom_banner_desktop),"min-height":"400px","aspect-ratio":_vm.xs ? 600 / 600 : 1920 / 400}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }